import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import { CustomCSS, createCustomCSSPrefixClassName } from '@elfsight/widget-ui';
import { meta } from './meta';
import type { VimeoGallerySettings } from './types';
import { Widget } from './widget/Widget';

export function VimeoGallery({
  widgetId = '',
  customCSS,
  customJS,
  editMode,
  renderThumbnailMode
}: VimeoGallerySettings) {
  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.appAlias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);

  return (
    <PortalNestProvider customCSSClassName={customCSSPrefixClassName}>
      <Widget />
      <CustomCSS
        customCSS={customCSS}
        prefixClassName={customCSSPrefixClassName}
      />
    </PortalNestProvider>
  );
}
